export const PERMISSION_SETTINGS_KEYS = [
	"groupsCanSeeTeamActivity",
	"groupsCanSeeTeamActivityWorkinghours",
	"groupsCanViewHourlyRates",
	"groupsCanSeePublicTimes",
	"groupsCanSeePrivateTimes",
	"groupsCanViewProjectTimesInAnalytics",
	"groupsCanManuallyCreateProjectTime",
	"groupsCanStartStopProjectTime",
	"groupsCanEditOwnProjectTimes",
	"groupsCanManuallyCreateWorkingTime",
	"groupsCanStartStopWorkingTime",
	"groupsCanCreateAbsences",
	"groupsCanEditOwnWorkingTimes",
	"groupsCanViewWorkingTimesInAnalytics",
	"groupsCanViewAllWorkingTimes",
	"groupsCanManageAllWorkingTimes",
	"groupsCanExportProjecthours",
	"groupsCanExportWorkinghours",
	"groupsCanExportTimeAccount",
	"groupsCanViewOwnTimeAccount",
	"groupsCanViewOtherTimeAccounts",
	"groupsCanManageTasks",
	"groupsCanCreateProjects",
	"groupsCanManageAllProjects",
	"groupsCanManageClients",
	"groupsCanManageTimes",
	"groupsCanManageTags",
	"groupsCanSeeProjectsInNavigation",
	"groupsCanSeeProfitability",
] as const;

export type PermissionSettingsKey = (typeof PERMISSION_SETTINGS_KEYS)[number];

/** Keys that still require group membership even for a workspace admin. Empty: admins bypass the matrix. */
export const PERMISSION_KEYS_WITHOUT_ADMIN_SHORTCUT = [] as const satisfies readonly PermissionSettingsKey[];
